import {Injectable} from '@angular/core';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class RilrService {

  constructor(private restangular: Restangular) {
  }

  getAllReports() {
    return this.restangular.all('getAllReports');
  }

  getAllReportsAlMaha() {
    return this.restangular.all('getAllReportsAlMaha');
  }

  getSelfAssessmentReports() {
    return this.restangular.all('getSelfAssessmentReports');
  }

  reportHeadersCRUD() {
    return this.restangular.all('reportHeadersCRUD');
  }

  reportHeadersMaterialInspection() {
    return this.restangular.one('reportHeadersMaterialInspection');
  }

  storeRIRAlkhorayef() {
    return this.restangular.all('storeRIRAlkhorayef');
  }

  storeRIRAlkhorayef2() {
    return this.restangular.all('storeRIRAlkhorayef2');
  }

  storeRIRAlkhorayef_objective() {
    return this.restangular.all('storeRIRAlkhorayef_objective');
  }



  storeSelfAssessmentAlkhorayef() {
    return this.restangular.all('storeSelfAssessmentAlkhorayef');
  }

  storeRIRAlmaha() {
    return this.restangular.all('storeRIRAlmaha');
  }

  reportHeadersStoreAlMaha() {
    return this.restangular.all('reportHeadersStoreAlMaha');
  }

  getReportFormData() {
    return this.restangular.one('getReportFormData');
  }

  getReportFormDataAlkhorayef() {
    return this.restangular.one('getReportFormDataAlkhorayef');
  }

  getReportFormDataAlMaha() {
    return this.restangular.one('getReportFormDataAlMaha');
  }

  getTypeheadEmployees() {
    return this.restangular.one('getTypeheadEmployees');
  }

  reportHeaderUD(id) {
    return this.restangular.one('reportHeadersCRUD/' + id);
  }

  reportHeaderUpdate() {
    return this.restangular.all('reportHeaderUpdate');
  }

  reportHeaderUpdateAlMaha() {
    return this.restangular.all('reportHeaderUpdateAlMaha');
  }

  reportAuditHeaderUpdate() {
    return this.restangular.all('reportAuditHeaderUpdate');
  }

  reportAuditHeaderUpdateMaterial() {
    return this.restangular.all('reportAuditHeaderUpdateMaterial');
  }

  reportAuditHeaderUpdateAlMaha() {
    return this.restangular.all('reportAuditHeaderUpdateAlMaha');
  }

  reportMVCHeaderUpdate() {
    return this.restangular.all('reportMVCHeaderUpdate');
  }

  reportMVCAlMahaHeaderUpdate() {
    return this.restangular.all('reportMVCAlMahaHeaderUpdate');
  }

  reportMeetingHeaderUpdate() {
    return this.restangular.all('reportMeetingHeaderUpdate');
  }

  meetingHeaderUpdateAlMaha() {
    return this.restangular.all('meetingHeaderUpdateAlMaha');
  }

  reportQuestionnaireHeaderUpdate() {
    return this.restangular.all('reportQuestionnaireHeaderUpdate');
  }

  reportWorkPermitUpdate() {
    return this.restangular.all('reportWorkPermitUpdate');
  }

  reportCorrectiveActionsCRUD() {
    return this.restangular.all('reportCorrectiveActionsCRUD');
  }

  reportCorrectiveActionsCRUDMultiple() {
    return this.restangular.all('reportCorrectiveActionsCRUDMultiple');
  }

  reportCorrectiveActionsUD(id) {
    return this.restangular.all('reportCorrectiveActionsCRUD/' + id);
  }

  getAllCorrectiveActions() {
    return this.restangular.one('getAllCorrectiveActions');
  }


  getSelectedCorrectiveActions() {
    return this.restangular.one('getSelectedCorrectiveActions');
  }





  getAllDeletedCorrectiveActions() {
    return this.restangular.one('getAllDeletedCorrectiveActions');
  }

  reportCorrectiveActionsHistory() {
    return this.restangular.one('reportCorrectiveActionsHistory');
  }

  injuredPersonDetailsCRUD() {
    return this.restangular.all('injuredPersonDetailsCRUD');
  }

  

  equipmentDetailsCRUD() {
    return this.restangular.all('equipmentDetailsCRUD');
  }


  injuredPersonDetailUD(id) {
    return this.restangular.all('injuredPersonDetailsCRUD/' + id);
  }

  getAllInjuredPersonDetails() {
    return this.restangular.one('getAllInjuredPersonDetails');
  }

  getAllequipmentDetails(){
    return this.restangular.one('equipmentDetailsCRUD');
  }

  equipmentDetailsUD(id) {
    return this.restangular.all('equipmentDetailsCRUD/' + id);
  }

  checkAllCorrectiveActionsClosed() {
    return this.restangular.all('checkAllCorrectiveActionsClosed');
  }

  getAllAuditorsDetails() {
    return this.restangular.one('getAllAuditorsDetails');
  }
 



  storeAuditorsDetailCRUD() {
    return this.restangular.all('reportAuditorsCRUD');
  }

  updateIncidentEmployee() {
    return this.restangular.all('updateIncidentEmployee');
  }





  // getCalendarEvents(id) {
  //   return this.restangular.one('calendar-events/'+id);
  // }

  getCalendarEvents(id, companySystemID) {
    return this.restangular.one('calendar-events/'+id + '/' +companySystemID);
  }


  auditorsDetailUD(id) {
    return this.restangular.all('reportAuditorsCRUD/' + id);
  }

  storeContractorDetailCRUD() {
    return this.restangular.all('reportContractorsCRUD');
  }
  
  updateAttended() {
    return this.restangular.all('updateAttended');
  }

  updateAttendedAuditors() {
    return this.restangular.all('updateAttendedAuditors');
  }


  updateupdateType() {
    return this.restangular.all('updateType');
  }


  updateupdateType1() {
    return this.restangular.all('updateTypea');
  }


  updateupdateType2() {
    return this.restangular.all('updateTypeb');
  }


  updateisEscalator() {
    return this.restangular.all('updateisEscalator');
  }


  getAllContractorDetails() {
    return this.restangular.one('getAllContractorDetails');
  }

  contractorDetailUD(id) {
    return this.restangular.all('reportContractorsCRUD/' + id);
  }

  reportRemoveUpdate() {
    return this.restangular.all('reportRemoveUpdate');
  }

  correctiveActionsReopen() {
    return this.restangular.all('correctiveActionsReopen');
  }

  getReportDynamicColumns() {
    return this.restangular.one('getReportDynamicColumns');
  }

  validateRILRReport() {
    return this.restangular.all('validateRILRReport');
  }

  generateRILRReport() {
    return this.restangular.all('generateRILRReport');
  }

  getHumanbodyparts() {
    return this.restangular.all('getHumanbodyparts');
  }

  getAllMyReports() {
    return this.restangular.all('getAllMyReports');
  }

  getAllMyReportsAlmaha() {
    return this.restangular.all('getAllMyReportsAlmaha');
  }

  getAllMyAssignedCorrectiveActions() {
    return this.restangular.all('getAllMyAssignedCorrectiveActions');
  }

  getAllCACreatedByMeAlmaha() {
    return this.restangular.all('getAllCACreatedByMeAlmaha');
  }

  getAllCreatedByMeCorrectiveActions() {
    return this.restangular.all('getAllCreatedByMeCorrectiveActions');
  }

  getAllMyAssignedCAAlmaha() {
    return this.restangular.all('getAllMyAssignedCAAlmaha');
  }

  getAllAssignedCorrectiveActionsLPT() {
    return this.restangular.all('getAllAssignedCorrectiveActionsLPT');
  }

  getAllAssignedCALPTAlmaha() {
    return this.restangular.all('getAllAssignedCALPTAlmaha');
  }

  getAllAssignedCADepartmentAlmaha() {
    return this.restangular.all('getAllAssignedCADepartmentAlmaha');
  }

  getRilrInjuryDropdown() {
    return this.restangular.one('getRilrInjuryDropdown');
  }

  getDynamicSubcategory() {
    return this.restangular.one('getDynamicSubcategory');
  }

  getDynamicMaincategoryAutoid() {
    return this.restangular.one('getDynamicMaincategoryAutoid');
  }

  reportCorrectiveActionCommentsCRUD() {
    return this.restangular.all('reportCorrectiveActionComments');
  }

  getCorrectiveActionComments() {
    return this.restangular.one('getCorrectiveActionComments');
  }

  getCorrectiveActionHistory() {
    return this.restangular.one('getCorrectiveActionHistory');
  }

  getIncidentCrossDetails() {
    return this.restangular.one('getIncidentCrossDetails');

  }

  reportPrintPreviewData() {
    return this.restangular.one('reportPrintPreviewData');
  }

  reportPrintPreviewDataAlmaha() {
    return this.restangular.one('reportPrintPreviewDataAlmaha');
  }

  reportNCRPrintPreviewData() {
    return this.restangular.one('reportNCRPrintPreviewData');
  }

  getCustomerByCountry() {
    return this.restangular.one('getCustomerByCountry');
  }


  getCustomerByCountryMulti() {
    return this.restangular.all('getCustomerByCountryMulti');
  }

  getSupplierByCountry() {
    return this.restangular.one('getSupplierByCountry');
  }

  getProjectByCountry() {
    return this.restangular.one('getProjectByCountry');
  }

  getRigByCountry() {
    return this.restangular.one('getRigByCountry');
  }

  monthlyEntryHeaderTable() {
    return this.restangular.all('monthlyEntryHeaderTable');
  }

  monthlyEntryHeaderTableAlMaha() {
    return this.restangular.all('monthlyEntryHeaderTableAlMaha');
  }

  monthlySafetyDataEntryData() {
    return this.restangular.one('monthlySafetyDataEntryData');
  }

  monthlySafetyDataEntryDataAlMaha() {
    return this.restangular.one('monthlySafetyDataEntryDataAlMaha');
  }

  storeMonthlySafetyData() {
    return this.restangular.all('monthly_safety_headers');
  }

  storeMonthlySafetyDataAlMaha() {
    return this.restangular.all('storeMonthlySafetyDataAlMaha');
  }

  monthlySafeDelete(monthlySafetyID) {
    return this.restangular.one('monthly_safety_headers/' + monthlySafetyID);
  }

  generateLeaderShipBoard() {
    return this.restangular.all('generateLeaderShipBoard');
  }

  getLeadershipFormData() {
    return this.restangular.one('getLeadershipFormData');
  }

  getAllApprovalsRecords() {
    return this.restangular.one('getAllApprovalsRecords');
  }

  storeScatMasterData() {
    return this.restangular.all('storeScatMasterData');
  }

  getScatDetailsView() {
    return this.restangular.one('getScatDetailsView');
  }

  removeScatMasterData() {
    return this.restangular.all('removeScatMasterData');
  }

  generateScatCorrectiveActionsAuto() {
    return this.restangular.one('generateScatCorrectiveActionsAuto');
  }

  printReportPDF() {
    return this.restangular.one('printReportPDF');
  }

  printRIRReportPDF() {
    return this.restangular.one('printRIRReportPDF');
  }


  printRIRReportPDFAI() {
    return this.restangular.all('printRIRReportPDFAI');
  }

  printRIRReportPDFArabian() {
    return this.restangular.all('printRIRReportPDFArabian');
  }




  printRIRReportPDFAudit() {
    return this.restangular.one('printRIRReportPDFAudit');
  }

  getCustomReport() {
    return this.restangular.one('getCustomReport');
  }









  
  printRIRReportPDFAlmaha() {
    return this.restangular.one('printRIRReportPDFAlmaha');
  }

  printPermitToWorkPDF() {
    return this.restangular.one('printPermitToWorkPDF');
  }

  getAllAuditDetails() {
    return this.restangular.one('getAllAuditDetails');
  }

  getLoggedUserReportAccess() {
    return this.restangular.one('getLoggedUserReportAccess');
  }

  getInvestigationTeamUserAccess() {
    return this.restangular.one('getInvestigationTeamUserAccess');
  }

  getReportFiltersFormData() {
    return this.restangular.one('getReportFiltersFormData');
  }

  printLeadershipBoardPDF() {
    return this.restangular.all('printLeadershipBoardPDF');
  }

  amendMonthlySafetyAlMaha() {
    return this.restangular.all('amendMonthlySafetyAlMaha');
  }

  getCorrectiveActionAreas() {
    return this.restangular.one('getCorrectiveActionAreas');
  }

  getAlMahaMonthlySafetyMultiple() {
    return this.restangular.one('getAlMahaMonthlySafetyMultiple');
  }

  storeAlMahaMonthlySafetyMultiple() {
    return this.restangular.one('storeAlMahaMonthlySafetyMultiple');
  }

  deleteAlMahaMonthlySafetyMultiple() {
    return this.restangular.one('deleteAlMahaMonthlySafetyMultiple');
  }

  deleteAlMahaMonthlySafetyMultipleFirst() {
    return this.restangular.one('deleteAlMahaMonthlySafetyMultipleFirst');
  }

  monthlyPerformancePrintPreviewData() {
    return this.restangular.one('monthlyPerformancePrintPreviewData');
  }

  storeIncidentNotificationMultiple() {
    return this.restangular.one('storeIncidentNotificationMultiple');
  }

  getIncidentNotificationMultiple() {
    return this.restangular.one('getIncidentNotificationMultiple');
  }

  deleteIncidentNotificationMultiple() {
    return this.restangular.one('deleteIncidentNotificationMultiple');
  }

  incidentNotificationMultipleUD(id) {
    return this.restangular.one('incident_detail_multiples/' + id);
  }




  iCamInvestigationCRUDNew(id) {
    return this.restangular.one('iCamInvestigationCRUD/' + id);
  }

  updateICAMInvestiMethod(id) {
    return this.restangular.one('updateICAMInvestiMethod/' + id);
  }

  updateAssetManual(id) {
    return this.restangular.one('updateAssetManual/' + id);
  }






  reportCorrectiveActionsStoreAlMaha() {
    return this.restangular.all('reportCorrectiveActionsStoreAlMaha');
  }

  reportFindingsStoreAlMaha() {
    return this.restangular.all('reportFindingsStoreAlMaha');
  }

  reportCorrectiveActionAlMahaUD() {
    return this.restangular.all('reportCorrectiveActionAlMahaUD');
  }

  reportFindingActionAlMahaUD() {
    return this.restangular.all('reportFindingActionAlMahaUD');
  }

  getQuestionDetailAnswear() {
    return this.restangular.one('getQuestionDetailAnswear');
  }

  reportIncidentNotificationCloseAlMaha() {
    return this.restangular.all('reportIncidentNotificationCloseAlMaha');
  }

  storeCorrectiveACommentsForward() {
    return this.restangular.all('storeCorrectiveACommentsForward');
  }

  storeCorrectiveACommentsForwardAlmaha() {
    return this.restangular.all('storeCorrectiveACommentsForwardAlmaha');
  }

  getActionForwardUpdatedUser() {
    return this.restangular.one('getActionForwardUpdatedUser');
  }

  monthlySafetyMultipleUD(id) {
    return this.restangular.one('monthly_safety_multiples/' + id);
  }

  removeCAUserAccess() {
    return this.restangular.one('removeCAUserAccess');
  }

  monthlySafetyPerformanceReturnReport() {
    return this.restangular.all('monthlySafetyPerformanceReturnReport');
  }

  hseMonthlyReportAlmaha() {
    return this.restangular.all('hseMonthlyReportAlmaha');
  }

  getERDTotalHoursCalculatedAlmaha() {
    return this.restangular.one('getERDTotalHoursCalculatedAlmaha');
  }

  getAuditReportSummaryAlkhorayef() {
    return this.restangular.one('getAuditReportSummaryAlkhorayef');
  }

  reportEmailForward() {
    return this.restangular.all('reportEmailForward');
  }

  getHSEPersonnelReports() {
    return this.restangular.all('getHSEPersonnelReports');
  }

  hsePersonnelReportDataAlMaha() {
    return this.restangular.one('hsePersonnelReportDataAlMaha');
  }

  storeHsePersonnelReportAlMaha() {
    return this.restangular.all('storeHsePersonnelReportAlMaha');
  }

  hsePersonnelDetailUD(id) {
    return this.restangular.one('hse_personnel_details/' + id);
  }

  allCorrectiveActionsReport() {
    return this.restangular.all('allCorrectiveActionsReport');
  }

  allCorrectiveActionsReportDtbl() {
    return this.restangular.all('allCorrectiveActionsReportDtbl');
  }

  allNcrReport() {
    return this.restangular.all('allNcrReport');
  }

  printPDFMonthlySafetyPerformance() {
    return this.restangular.all('printPDFMonthlySafetyPerformance');
  }

  printPDFCorrectiveActionReport() {
    return this.restangular.all('printPDFCorrectiveActionReport');
  }

  mpsContractorReport() {
    return this.restangular.all('mpsContractorReport');
  }

  hsePersonnelDetails() {
    return this.restangular.one('hsePersonnelDetails');
  }

  printPDFMpsContractorReport() {
    return this.restangular.all('printPDFMpsContractorReport');
  }

  printPDFhseMonthlyReportAlMaha() {
    return this.restangular.all('printPDFhseMonthlyReportAlMaha');
  }

  getMOCAnalysisApprovalAccess() {
    return this.restangular.one('getMOCAnalysisApprovalAccess');
  }

  getMOCApprovalUsersEditAccess() {
    return this.restangular.one('getMOCApprovalUsersEditAccess');
  }

  getNCRFirstLevelApprover() {
    return this.restangular.one('getNCRFirstLevelApprover');
  }

  getChecklistCategoryAlkhorayef() {
    return this.restangular.one('getChecklistCategoryAlkhorayef');
  }

  getCorrectiveActionReopenAccess() {
    return this.restangular.one('getCorrectiveActionReopenAccess');
  }

  inspectionChecklistStoreAlkhorayef() {
    return this.restangular.all('inspectionChecklistStoreAlkhorayef');
  }

  printAllReportsPDF() {
    return this.restangular.all('printAllReportsPDF');
  }

  printAllReportsNCRPDF() {
    return this.restangular.all('printAllReportsNCRPDF');
  }

  printAllReportsMOCPDF() {
    return this.restangular.all('printAllReportsMOCPDF');
  }

  accidentReportSafetyAlert() {
    return this.restangular.one('accidentReportSafetyAlert');
  }

  accidentReportSafetyAlertPDF() {
    return this.restangular.all('accidentReportSafetyAlertPDF');
  }

  generateEmployeeReportCount() {
    return this.restangular.all('generateEmployeeReportCount');
  }

  fillingStationMatrixReport() {
    return this.restangular.all('fillingStationMatrixReport');
  }

  printFillingStationMatrixReport() {
    return this.restangular.all('printFillingStationMatrixReport');
  }

  hseCommunicationLogReport() {
    return this.restangular.all('hseCommunicationLogReport');
  }

  printHseCommunicationLogReport() {
    return this.restangular.all('printHseCommunicationLogReport');
  }

  storeCommunicationLogHistory() {
    return this.restangular.all('storeCommunicationLogHistory');
  }

  checkLastCheckFindingsValue() {
    return this.restangular.one('checkLastCheckFindingsValue');
  }

  checkConfidentialReportAccess() {
    return this.restangular.one('checkConfidentialReportAccess');
  }

  getCorrectiveActionCreateAccess() {
    return this.restangular.one('getCorrectiveActionCreateAccess');
  }

  getAuditFindingAccess() {
    return this.restangular.one('getAuditFindingAccess');
  }

  reportFindingAlMahaUD() {
    return this.restangular.all('reportFindingAlMahaUD');
  }

  getCheckListAllData() {
    return this.restangular.one('getCheckListAllData');
  }

  documentBaseReports() {
    return this.restangular.one('documentBaseReports');
  }

  amendNcrReport() {
    return this.restangular.one('amendRejectNcrReport');
  }

  countryBaseData() {
    return this.restangular.one('countryBaseData');
  }

  allFindingsActionsReport() {
    return this.restangular.all('allFindingsActionsReport');
  }

  updateNCRValidityClosedReport() {
    return this.restangular.one('updateNCRValidityClosedReport');
  }

  reopenMocReport() {
    return this.restangular.one('reopenMocReport');
  }

  reopenPermitWorkReport() {
    return this.restangular.one('reopenPermitWorkReport');
  }

  getEmployeeDeleteReportAccess() {
    return this.restangular.one('getEmployeeDeleteReportAccess');
  }

  deleteReportBasedAccess() {
    return this.restangular.all('deleteReportBasedAccess');
  }

  hseClosureApprovalReport() {
    return this.restangular.all('hseClosureApprovalReport');
  }

  qualityClosureApprovalsReport() {
    return this.restangular.all('qualityClosureApprovalsReport');
  }

  printPDFHseClosureApprovalReport() {
    return this.restangular.all('printPDFHseClosureApprovalReport');
  }

  hseClosureReportPDFNesr() {
    return this.restangular.all('hseClosureReportPDFNesr');
  }

  printPDFQualityClosureApprovalsReport() {
    return this.restangular.all('printPDFQualityClosureApprovalsReport');
  }

  monthlySafetyAlmahaReportData() {
    return this.restangular.one('monthlySafetyAlmahaReportData');
  }

  getReportsPreviewAlmaha() {
    return this.restangular.all('getReportsPreviewAlmaha');
  }

  public getCurrentCompanyDetail() {
    return this.restangular.one("getCurrentCompanyDetail");
  }

  updateCurrentCompanySettings() {
    return this.restangular.all('updateCurrentCompanySettings');
  }

  getCurrentCompanyLoginHistory() {
    return this.restangular.all('getCurrentCompanyLoginHistory');
  }

  reportHeadersStoreDynamic() {
    return this.restangular.all('reportHeadersStoreDynamic');
  }

  getDynamicReportViewRH() {
    return this.restangular.all('getDynamicReportViewRH');
  }

  updateTemplateMasterAssign() {
    return this.restangular.all('updateTemplateMasterAssign');
  }

  getTemplateAssignedRoute() {
    return this.restangular.one('getTemplateAssignedRoute');
  }

  checkAllAnalysisFilled() {
    return this.restangular.all('checkAllAnalysisFilled');
  }

  storeMonthlySafetyDataDynamic() {
    return this.restangular.all('storeMonthlySafetyDataDynamic');
  }

  monthlyEntryHeaderDynamicTable() {
    return this.restangular.all('monthlyEntryHeaderDynamicTable');
  }

  employeeWiseReportCount() {
    return this.restangular.all('employeeWiseReportCount');
  }

  printPDFEmployeeWiseReportCount() {
    return this.restangular.all('printPDFEmployeeWiseReportCount');
  }

  getSummarizedChecklist() {
    return this.restangular.one('getSummarizedChecklist');
  }

  employeeWiseReportCountDocument() {
    return this.restangular.all('employeeWiseReportCountDocument');
  }

  printPDFEmployeeWiseReportCountDoc() {
    return this.restangular.all('printPDFEmployeeWiseReportCountDoc');
  }

  getSegmentBySecondaryCompany() {
    return this.restangular.one('getSegmentBySecondaryCompany');
  }

  iCamReportHeaderUpdate() {
    return this.restangular.all('iCamReportHeaderUpdate');
  }

  auditStoreGeneral() {
    return this.restangular.all('auditStoreGeneral');
  }

  auditReportUpdateGeneral() {
    return this.restangular.all('auditReportUpdateGeneral');
  }

  getTypeMonthlySafetyFields() {
    return this.restangular.one('getTypeMonthlySafetyFields');
  }

  storeMonthlySafetyDataNesr() {
    return this.restangular.all('storeMonthlySafetyDataNesr');
  }

  monthlyEsgReport() {
    return this.restangular.all('monthlyEsgReport');
  }

  storeMonthlySafetyDataOfsat() {
    return this.restangular.all('storeMonthlySafetyDataOfsat');
  }

  getDocumentIncidentCausationDetails() {
    return this.restangular.one('getDocumentIncidentCausationDetails');
  }

  getSecondaryCompaniesList() {
    return this.restangular.all('getSecondaryCompaniesList');
  }

  public getEmailForwardConfiguration() {
    return this.restangular.one("email_forward_configurations");
  }

  updateEmailForwardConfiguration(id) {
    return this.restangular.one('email_forward_configurations/' + id);
  }

  removeMaterialItem(id) {
    return this.restangular.one("InspectionReportCRUD/" + id);
  }

  getAllActiveMaterials() {
    return this.restangular.all("getAllActiveMaterials");
  }

  public updateRILRActionEffective() {
    return this.restangular.all("updateRILRActionEffective");
  }









  getFiveWhyCriticalFactorTable() {
    return this.restangular.one('getFiveWhyCriticalFactorTable');
  }

  updateFiveWhyCriticalFactorTable() {
    return this.restangular.all('updateFiveWhyCriticalFactorTable');
  }

  getSubmittedFiveWhyCriticalFactors() {
    return this.restangular.one('getSubmittedFiveWhyCriticalFactors');
  }


  removeCriticalTableRow() {
    return this.restangular.one('removeCriticalTableRow');
  }



  getCriticalFactorsFromICAM() {
    return this.restangular.one('getCriticalFactorsFromICAM');
  }


  
  
  updateOtherDamageDetails(id) {
    return this.restangular.one("updateOtherDamageDetails/" + id);
  }




  public handleCheckboxChange(id) {
    return this.restangular.one("handleCheckboxChange/" + id);
  }


  
  clearRiskMatrix(id) {
    return this.restangular.one("clearRiskMatrix/" + id);
  }


  getInjieyEquipmentRecord() {
    return this.restangular.one('getInjieyEquipmentRecord');
  }




  getEmployeeAnswers(reportID: number, assessment_id: number) {
    return this.restangular.one(`getEmployeeAnswers/${reportID}/${assessment_id}`);
  }


  public getCompanyEmployeeDocuments() {
    return this.restangular.all("getCompanyEmployeeDocuments");
  }


  public saveCompanyEmployeeDocuments() {
    return this.restangular.one("saveCompanyEmployeeDocuments");
  }


  public getCompanyEmployeeDocumentsAll() {
    return this.restangular.all("getCompanyEmployeeDocumentsAll");
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/rilr.service.ts